import { render, staticRenderFns } from "./CanvasSection.vue?vue&type=template&id=13b20ae9&"
import script from "./CanvasSection.vue?vue&type=script&lang=js&"
export * from "./CanvasSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports